import { render } from "./SelectStaff.vue?vue&type=template&id=b350cf92&scoped=true"
import script from "./SelectStaff.vue?vue&type=script&lang=js"
export * from "./SelectStaff.vue?vue&type=script&lang=js"

import "./SelectStaff.vue?vue&type=style&index=0&id=b350cf92&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b350cf92"]])

export default __exports__